<template>
  <page-header-wrapper>
    <div slot="extra">
      <router-link v-action:add :to="{ path: '/activities/form' }">
        <a-button type="primary" icon="plus">新建活动</a-button>
      </router-link>
    </div>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="inline">
        <standard-form-row block>
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px;"
              v-model="params.where.title"
              placeholder="请输入标题"
              enter-button
              @search="getLists()"
            />
            <a-button type="link" @click="() => (this.search = !this.search)">
              高级筛选
              <a-icon :type="search ? 'up' : 'down'" />
            </a-button>
          </div>
        </standard-form-row>
        <template v-if="search">
          <standard-form-row title="创建日期" block>
            <a-form-item :wrapper-col="{ sm: { span: 8 }, xs: { span: 24 } }">
              <a-range-picker
                :ranges="{
                  最近七天: [moment().subtract('days', 6), moment()],
                  今天: [moment(), moment()],
                  本月: [moment().startOf('month'), moment()]
                }"
                :placeholder="['开始日期', '结束日期']"
                @change="value => handleChangeDate(value)"
                style="width: 100%"
              />
            </a-form-item>
          </standard-form-row>
          <standard-form-row title="活动日期" block>
            <a-form-item :wrapper-col="{ sm: { span: 8 }, xs: { span: 24 } }">
              <a-range-picker
                :ranges="{
                  最近七天: [moment().subtract('days', 6), moment()],
                  今天: [moment(), moment()],
                  本月: [moment().startOf('month'), moment()]
                }"
                :placeholder="['开始日期', '结束日期']"
                @change="value => handleChangeDate(value, ['start_time', 'end_time'])"
                style="width: 100%"
              />
            </a-form-item>
          </standard-form-row>
          <standard-form-row title="排序" grid>
            <a-row>
              <a-col :lg="20" :md="20" :sm="24" :xs="24">
                <a-form-item :wrapper-col="{ sm: { span: 20 }, xs: { span: 24 } }">
                  <a-radio-group v-model="orderID" @change="handleChangeOrder">
                    <a-radio-button value="id">ID</a-radio-button>
                    <a-radio-button value="sort">排序</a-radio-button>
                    <a-radio-button value="created_at">创建时间</a-radio-button>
                    <a-radio-button value="updated_at">修改时间</a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :lg="4" :md="4" :sm="24" :xs="24">
                <a-form-item :wrapper-col="{ sm: { span: 24 }, xs: { span: 24 } }">
                  <a-select
                    placeholder="不限"
                    v-model="orderVal"
                    style="width: 120px"
                    @change="handleChangeOrder"
                  >
                    <a-select-option value="asc">升序</a-select-option>
                    <a-select-option value="desc">降序</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </standard-form-row>
        </template>
      </a-form>
    </a-card>
    <a-card style="margin-top: 24px;" :bordered="false">
      <div slot="extra" class="change-state">
        <a-radio-group @change="searchChangeState">
          <a-radio-button value="0">全部</a-radio-button>
          <a-radio-button value="1">展示</a-radio-button>
          <a-radio-button value="2">隐藏</a-radio-button>
        </a-radio-group>

      </div>
      <a-list size="default" :loading="loading" :pagination="pagination">
        <a-list-item :key="index" v-for="(item, index) in list">
          <a-list-item-meta>
            <viewer slot="avatar" class="link-pic">
              <a-avatar :size="150" shape="square" :src="globalUrl + item.thumb" v-if="item.thumb" />
            </viewer>
            <a slot="title" :title="item.title">{{ item.title }}</a>
            <template slot="description">
              <div class="list-items">
                <span>
                  创建时间：
                  <a-tag color="blue">{{ moment(item.created_at).fromNow() }}</a-tag>
                </span>
                <span>
                  末次更新：
                  <a-tag color="green">{{ moment(item.updated_at).fromNow() }}</a-tag>
                </span>
              </div>
              <div class="list-items">
                <span>
                  开始时间：
                  <a-tag color="pink">
                    {{ moment(item.start_time * 1000).format('YYYY-MM-DD HH:mm:ss') }}
                  </a-tag>
                </span>

                <span v-if="item.end_time">
                  结束时间：
                  <a-tag color="gray">
                    {{ moment(item.end_time * 1000).format('YYYY-MM-DD HH:mm:ss') }}
                  </a-tag>
                </span>
              </div>
              <div class="list-items">
                排序：<a-tag color="red">{{ item.sort }}</a-tag>
                <template v-if="item.appointment > 0">
                  预约人数：
                  <a-tag color="yellow">
                    {{ item.appointment }}
                  </a-tag>
                </template>
              </div>
              <div class="list-items" v-if="item.keywords !== ''">
                关键词：
                <a-tag v-for="(lable, key) in (item.keywords || '').split(',')" :key="key">
                  {{ lable }}
                </a-tag>
              </div>
            </template>
          </a-list-item-meta>
          <div class="list-content">
            <div class="list-content-item">
              <a-switch
                v-action:state
                :checked="item.state === 1"
                @change="handleChangeState(item.id)"
                checked-children="展示"
                un-checked-children="隐藏"
              />
            </div>
          </div>
          <div slot="actions">
            <router-link v-action:update :to="'/activities/form/' + item.id">
              <a>编辑</a>
            </router-link>
          </div>
          <div slot="actions">
            <a-popconfirm
              title="确定要删除该信息吗？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleOnDelete(item.id)"
              v-action:delete
            >
              <a href="#">删除</a>
            </a-popconfirm>
          </div>
        </a-list-item>
      </a-list>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { list, select, card } from '@/mixins' // 引入
import { TagSelect } from '@/components'
const apiList = {
    getList: '/activities',
    delete: '/activities/',
    changeState: '/activities/'
}
const TagSelectOption = TagSelect.Option

export default {
    name: 'ActList',
    mixins: [list, select, card], // 使用mixins
    components: {
        TagSelect,
        TagSelectOption
    },
    data () {
        return {
            apiList
        }
    },
    mounted () {
        this.getLists() // 获取列表
    },
    methods: {}
}
</script>
